import ChipList from './ChipList';

export default ChipList;
